'use client';

import DesktopHeaderLayoutContainer from '@components/pages/common/DesktopHeaderLayoutContainer';
import DesktopSkeleton from '@components/pages/common/DesktopSkeleton';
import HeaderLayout from '@components/pages/common/HeaderLayoutContainer';
import { useLoading } from '@contexts/LoadingContext';
import { useMarketingPopupState } from '@contexts/MarketingPopupStateContext';
import { useScrollRestoration } from '@hooks/restoreScrollPosition';
import useAirBridgeEvent from '@hooks/useAirBridgeEvent';
import useGlobalState from '@hooks/useGlobalState';
import { WomenPageProps } from '@models/women';
import { currentUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import HomeSkeleton from '@wconcept/wconcept-ui-renewal/src/components/molecules/_skeleton/HomeSkeleton';
import MainTemplate from '@wconcept/wconcept-ui-renewal/src/components/templates/MainTemplate';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import React, { lazy, Suspense, useEffect, useState } from 'react';

const WomenDesktopPageCornerList = dynamic(
  () => import('../WomenPageCornerList'),
  {
    ssr: false,
    loading: () => <HomeSkeleton />,
  }
);

const WomenMobilePageCornerList = dynamic(
  () => import('../WomenPageCornerList'),
  {
    ssr: false,
    // suspense: true,
    loading: () => <HomeSkeleton />,
  }
);

const WomenPageFloatingBanner = dynamic(
  () => import('../WomenPageFloatingBanner'),
  {
    ssr: false,
  }
);

const pageClassName = 'main-page';

function WomenPageContainer() {
  const { isMobile, appInfo, initialData, assistData } =
    useGlobalState<WomenPageProps>();
  const { isAllLoaded } = useLoading(['womenCornerList']);
  useScrollRestoration(isAllLoaded);
  const { marketingPopup } = useMarketingPopupState();
  const { openAirBridgeAppBanner } = useAirBridgeEvent();
  const router = useRouter();

  useEffect(() => {
    window.kakaoPixel &&
      window.kakaoPixel('4785664593446063564')?.pageView(`women_main`);
  }, [appInfo.isNativeAppBoth]);

  useEffect(() => {
    if (!window.location.pathname.includes('rn/women')) {
      router.replace('/rn/women');
    }
  }, []);

  useEffect(() => {
    openAirBridgeAppBanner();
  }, [openAirBridgeAppBanner]);

  return !isMobile ? (
    <DesktopHeaderLayoutContainer
      className="main-page"
      megaMenu={initialData?.megaMenu}
      gnbInfo={initialData?.gnbInfo || []}
      searchInitInfo={initialData?.searchInitInfo}
    >
      <MainTemplate>
        <Suspense fallback={<DesktopSkeleton />}>
          <WomenDesktopPageCornerList id="womenCornerList" />
        </Suspense>
      </MainTemplate>
    </DesktopHeaderLayoutContainer>
  ) : (
    <HeaderLayout
      className={pageClassName}
      gnbInfo={initialData?.gnbInfo}
      gnbType="Y"
      logoInfo={initialData?.logoInfo?.biLogo}
      selectedGnbValue="/rn/women"
      headerBgType="transparent"
      gnbStyleType="liquidGlass"
    >
      <MainTemplate>
        <Suspense fallback={<HomeSkeleton />}>
          <WomenMobilePageCornerList id="womenCornerList" />
        </Suspense>
        <WomenPageFloatingBanner
          floatingInfo={marketingPopup?.floatingBanner}
        />
      </MainTemplate>
    </HeaderLayout>
  );
}

export default WomenPageContainer;
